import React, { forwardRef, KeyboardEvent, ChangeEvent } from 'react';
import './SearchInput.scss';

interface SearchInputProps {
  showSearchIcon: boolean;
  placeholder: string;
  value: string;
  onChange: (e: ChangeEvent) => void;
  onKeyDown: (e: KeyboardEvent) => void;
  onClearBtnClick: () => void;
}

export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(
  ({ showSearchIcon, placeholder, value, onChange, onKeyDown, onClearBtnClick }, ref) => {
    return (
      <div className='l-search-panel-container'>
        <input
          ref={ref}
          className='c-search-bar'
          type='text'
          autoCapitalize='none'
          autoComplete='off'
          autoCorrect='off'
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
        />
        {showSearchIcon && !value && <i className='icon-symbol-search c-search-icon' />}
        {value && <i onClick={onClearBtnClick} className='icon-symbol-close c-clear-icon' />}
      </div>
    );
  }
);
